import { useContextMenu } from "components/ContextMenu/useContextMenu";
import { PropsWithChildren } from "react";
import { createPortal } from "react-dom";
import "./ContextMenu.scss";

interface ContextMenuProps extends ContextMenuWrapperProps {
    top: number;
    left: number;
    menuRef: any;
}

const CustomContextMenu = ({ top, left, handleClick, menuRef }: ContextMenuProps) => {
    return (
        <div
            style={{
                top,
                left,
            }}
            onClick={handleClick}
            className="customContextMenu"
            ref={menuRef}
        >
            Add as a filter
        </div>
    );
};

interface ContextMenuWrapperProps {
    handleClick: () => void;
}

export const ContextMenuWrapper = ({
    children,
    handleClick,
}: PropsWithChildren<ContextMenuWrapperProps>) => {
    const { menu, onContextMenuClick, ref, menuRef } = useContextMenu();

    return (
        <div onContextMenu={onContextMenuClick} ref={ref}>
            {menu &&
                createPortal(
                    <CustomContextMenu menuRef={menuRef} handleClick={handleClick} {...menu} />,
                    document.body
                )}
            {children}
        </div>
    );
};
